import React, { PureComponent } from 'react';

import { connect } from 'react-redux';

import { Repository } from 'src/components/types';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import SourcePage from '../components';
import FileHistory from '../components/file-history';
import FileHistoryHeader from '../components/file-history-header';

import CurrentFileFetcher from './current-file-fetcher';

type ConnectedFileHistoryProps = {
  hash: string | null | undefined;
  path: string;
  repository: Repository | null | undefined;
};

const mapStateToProps = (state: BucketState) => ({
  hash: state.repository.source.section.hash,
  repository: getCurrentRepository(state),
});

export default connect(mapStateToProps)(
  class ConnectedFileHistory extends PureComponent<ConnectedFileHistoryProps> {
    render() {
      const { hash, path, repository } = this.props;

      return (
        <SourcePage
          header={<FileHistoryHeader path={path} />}
          path={path}
          repository={repository}
        >
          <CurrentFileFetcher />
          <FileHistory
            path={path}
            refOrHash={hash}
            repositoryFullSlug={repository ? repository.full_name : null}
          />
        </SourcePage>
      );
    }
  }
);
